import { Button } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import useAPI from "../../../../api/hooks/useAPI";
import useColors from "../../../../api/hooks/useColors";
import CustomToolTip from "../../../../components/CustomTooltip";
import SpinningIcon from "../../../../components/SpinningIcon";
import { Toast } from "../../../../components/Toast";
import ConfirmationDialog from "../../../../components/dialogs/ConfirmationDialog";
import { NotificationContext } from "../../../../contexts/NotificationContext";

const NightlyFlowButton = ({ loadingMessage, setLoading, ...props }) => {
  const { isLoading, setIsLoading, setIsScanning, setTaskId } =
    useContext(NotificationContext);
  const colors = useColors();
  const { runNightlyFlow } = useAPI();
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    setLoading(isLoading);
  }, [isLoading, setLoading]);

  const handleButtonClick = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleConfirm = async () => {
    setIsLoading(true);
    runNightlyFlow().then((result) => {
      setIsScanning(true);
      Toast.info("Updating data in the background...");
      setTaskId(result.data);
    });
    setOpenDialog(false);
  };

  return (
    <>
      <CustomToolTip title={isLoading ? loadingMessage : ""}>
        <Button
          sx={{
            background: colors.grey_50,
            color: colors.contrast_text_dark,
            height: "32px",
            marginLeft: "5px",
            border: "1px solid",
            borderRadius: "8px",
          }}
          startIcon={<SpinningIcon isLoading={isLoading} />}
          onClick={handleButtonClick}
          disabled={isLoading}
          {...props}
        >
          {isLoading ? "Scanning..." : "Run Nightly Flow"}
        </Button>
      </CustomToolTip>
      <ConfirmationDialog
        openDialog={openDialog}
        handleDialogClose={handleDialogClose}
        handleConfirm={handleConfirm}
        dialogContentFirstLine="Are you sure you want to run nightly flow?"
        dialogContentSecondLine="This action can take ±30 minutes."
        confirmationButtonText="Scan"
      />
    </>
  );
};

export default NightlyFlowButton;
